export default __webpack_public_path__ + "316af330863dca3d5472db94f584a58b.svg";